/**
 * Stop Task Force emails from a link in one (18 Oct 2026), without signing in. Asks first, so a mail scanner that
 * opens links changes nothing; mail apps' own unsubscribe button goes straight to the API.
 */
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { TfMark } from '../taskforce/brand';
import '../styles/taskforce.css';

export function Unsubscribe() {
  const [params] = useSearchParams();
  const t = params.get('t') ?? '';
  const [label, setLabel] = useState<string | null>(null);
  const [state, setState] = useState<'ask' | 'busy' | 'done' | 'bad'>('ask');
  useEffect(() => {
    api<{ label: string }>(`/api/email/unsubscribe?t=${encodeURIComponent(t)}`)
      .then((r) => setLabel(r.label))
      .catch(() => setState('bad'));
  }, [t]);
  const stop = async () => {
    setState('busy');
    try {
      await api('/api/email/unsubscribe', { method: 'POST', json: { t } });
      setState('done');
    } catch (e) {
      setState(e instanceof ApiError && e.status === 400 ? 'bad' : 'ask');
    }
  };
  return (
    <main className="tfna" aria-labelledby="unsubTitle">
      <div className="tfna-card">
        <TfMark size={48} />
        {state === 'bad' ? (
          <>
            <h1 id="unsubTitle">This link does not work</h1>
            <p className="tfna-lead">Choose which emails you get in Task Force's notification settings instead.</p>
          </>
        ) : state === 'done' ? (
          <>
            <h1 id="unsubTitle">Done</h1>
            <p className="tfna-lead">
              You won’t get emails for: <b>{label}</b>. You can turn them back on any time in your notification
              settings.
            </p>
          </>
        ) : (
          <>
            <h1 id="unsubTitle">Stop these emails?</h1>
            <p className="tfna-lead">{label ? <b>{label}</b> : '…'}</p>
            <button
              type="button"
              className="tfbtn primary"
              disabled={!label || state === 'busy'}
              onClick={() => void stop()}
            >
              {state === 'busy' ? 'Stopping…' : 'Stop these emails'}
            </button>
          </>
        )}
        <Link to="/taskforce/-/inbox?settings=1">Notification settings</Link>
      </div>
    </main>
  );
}
